module.exports = __webpack_public_path__ + "img/youtube.97854c84.png";